import { render, staticRenderFns } from "./SchoolSessionsIndex.vue?vue&type=template&id=a059f488"
import script from "./SchoolSessionsIndex.vue?vue&type=script&lang=js"
export * from "./SchoolSessionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports